import {ChangeDetectionStrategy, Component, computed, input, linkedSignal} from '@angular/core';
import {ProtokollførtMøtedeltakerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {DokumentSigneringInformasjon} from "felles-ng2/tjenester/DokumentSigneringInformasjon";
import {PercentPipe} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatTooltip} from "@angular/material/tooltip";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {primærRolleSomStreng} from "felles-ng2/modell/medlemsRollePeriodeModellHjelpere";

const debug = initDebugger('ProtokollførtDeltakerinformasjonKomponent');

@Component({
    selector: 'protokollfoert-deltakerinformasjon',
    templateUrl: 'protokollført-deltakerinformasjon.html',
    styleUrl: 'protokollført-deltakerinformasjon.scss',
    host: {
        'data-testid': 'deltakerinformasjon',
        '[class.uten-representerer-kolonne]': '!visRepresentererKolonne()'
    },
    imports: [
        TranslateModule,
        MatTooltip,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        PercentPipe,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtokollførtDeltakerinformasjonKomponent {

    deltaker = input.required<ProtokollførtMøtedeltakerModell>();
    visRepresentererKolonne = input<boolean>(false);

    aktivRolleTittel = computed(() => primærRolleSomStreng(this.deltaker().aktiveMedlemsroller));
    /** summen av eierandelene knyttet til aksjeeierne denne deltakeren representerer, som et tall mellom 0 og 100 */
    sumAndelIProsent = computed(() =>
      this.deltaker().aksjeeierRepresentasjoner.reduce((sum, aksjeeierIMøte) => sum + aksjeeierIMøte.eierandel, 0));
    signeringsinformasjon = computed(() => {
        const signaturinformasjon = this.deltaker().signaturinformasjon;
        return signaturinformasjon ? this.dokumentSigneringInformasjon.signaturinformasjonSomTekst(signaturinformasjon) : '';
    });
    /** Sann dersom aksjeeier-representasjoner skal vises, default sann dersom deltaker kun representerer én aksjeeier */
    viserRepresentasjoner = linkedSignal(() => this.deltaker().aksjeeierRepresentasjoner.length === 1);

    constructor(private dokumentSigneringInformasjon: DokumentSigneringInformasjon) {
    }

    toggleRepresentasjoner() {
        this.viserRepresentasjoner.update(v => !v);
    }
}
